<template>
    <div class="mt-auto">
        <button
            class="phiolet_button c16 p1b w-100"
            @click="scheduleUpdates">
            {{buttonText}}
        </button>
    </div>
</template>

<script>
export default {
    name: 'ScheduleUpdates',
    props: {
        campaign: Object,
        buttonText: String
    },
    methods: {
        scheduleUpdates () {
            this.$sendMixpanelEvent('Edit Campaign Opened', {
                'Opened From': 'CpRequest Modal (Scheduled Now)',
                'Campaign Name': this.campaign.title
            })
            this.$ga.event('Campaign', 'Edit Campaign Open', `
                OpenedFrom: CpRequest Modal (Scheduled Now),
                Campaign: ${this.campaign.title}
            `)
            this.$router.push(`/edit-campaign?id=${this.campaign.id}&model=campaigns`).catch(() => {})
            this.$store.commit('TOGGLE_MODAL', ['cp-request', false])
        }
    }
}
</script>